





















import { Component, Prop, Vue } from 'vue-property-decorator';
import TypeCard from './TypeCard.vue';
import NewTypeCard from './NewTypeCard.vue';
import RequestsService from '@/mixins/requests.service';

@Component({
  components: {
    NewTypeCard,
    TypeCard,
  },
  mixins: [ RequestsService ],
})
export default class TypeBrowser extends Vue {
  private created(): void {
    this.$store.dispatch('leaveTypes/updateLeaveTypes', { force: true });
  }
}
